<template>
  <ModalDialog
    :header-text="`Cancel ${
      inspectionStore.isGroupVisit ? 'Group ' : ''
    }Visit Form`"
    contentClass="visit-modal-content"
    :canBeClosed="!formSubmitting"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <CancelVisitForm
        :visitId="visitId"
        :hideVisitId="hideVisitId"
        @visitCanceled="onFormClosed(true)"
        @submittingChanged="(value: boolean) => (formSubmitting = value)"
      />
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { ref } from "vue";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { useInspectionStore } from "@/stores/useInspectionStore";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import CancelVisitForm from "./CancelVisitForm.vue";

const notificationStore = useNotificationStore();
const inspectionStore = useInspectionStore();

const emit = defineEmits<{
  (e: "closeModal", canceled: boolean): void;
}>();

defineProps<{
  visitId: number;
  hideVisitId?: boolean;
}>();

const formSubmitting = ref(false);

const onFormClosed = (canceled: boolean) => {
  emit("closeModal", canceled);
};

const closeModal = function (closed: boolean) {
  if (formSubmitting.value || !closed) {
    notificationStore.notify({
      type: NotificationTypeEnum.info,
      message: "Please wait while visit is being created",
      duration: 5000,
    });
    return;
  }
  emit("closeModal", false);
};
</script>

<style lang="scss">
.visit-modal-content {
  max-width: 800px;
  padding: 2rem;
  margin: 0 -20px;
}
</style>
